export default __webpack_public_path__ + "static/media/icon-up-fill.9c4d6114.svg";